import styled from 'styled-components';
export const Layout = styled.div`
  padding-top: calc(100vw*(51/375));
`